module.exports = __webpack_public_path__ + "static/RemovePriceLabel-cb443189ad3a52466cf997f1647d37e1.png";